import { render } from "./StatsChoice.vue?vue&type=template&id=561720ca&scoped=true"
import script from "./StatsChoice.vue?vue&type=script&lang=js"
export * from "./StatsChoice.vue?vue&type=script&lang=js"

import "./StatsChoice.vue?vue&type=style&index=0&id=561720ca&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561720ca"]])

export default __exports__